export type CellPanelBox = {
  top: number
  left: number
  width: number
  maxHeight: number
}

export type CellPanelBoxInput = {
  anchor: { top: number; left: number; right: number; bottom: number }
  viewport: { width: number; height: number }
  panel: { width: number; height: number }
  minWidth?: number
  maxWidth?: number
  margin?: number
  gap?: number
}

function clamp(value: number, min: number, max: number): number {
  if (max < min) return min
  return Math.min(Math.max(value, min), max)
}

export function computeCellPanelBox({
  anchor,
  viewport,
  panel,
  minWidth = 288,
  maxWidth = 440,
  margin = 8,
  gap = 8,
}: CellPanelBoxInput): CellPanelBox {
  const spaceRight = viewport.width - margin - (anchor.right + gap)
  const spaceLeft = anchor.left - gap - margin
  const placeRight = spaceRight >= minWidth || spaceRight >= spaceLeft
  const availW = Math.max(0, placeRight ? spaceRight : spaceLeft)
  const width = Math.round(
    clamp(availW || minWidth, minWidth, Math.min(maxWidth, Math.max(minWidth, availW || minWidth))),
  )

  let left = placeRight ? anchor.right + gap : anchor.left - width - gap
  left = Math.round(clamp(left, margin, viewport.width - width - margin))

  const availH = Math.max(0, viewport.height - 2 * margin)
  const needed = panel.height > 0 ? Math.min(Math.round(panel.height), availH) : 0

  let top = anchor.top
  if (top < margin) top = margin
  const minFit = needed > 0 ? needed : Math.min(120, availH)
  if (top + minFit > viewport.height - margin) top = viewport.height - margin - minFit
  if (top < margin) top = margin

  const maxHeight = Math.round(Math.max(0, viewport.height - margin - top))
  return { top: Math.round(top), left, width, maxHeight }
}

export function measuredPanelNeed(panel: HTMLElement): { width: number; height: number } {
  const body = panel.querySelector('[data-cell-panel-body]') as HTMLElement | null
  const height = body
    ? panel.offsetHeight - body.clientHeight + body.scrollHeight
    : panel.scrollHeight
  return { width: panel.offsetWidth, height }
}
